// extracted by mini-css-extract-plugin
export default {"container":"Second_container__JIuli","content":"Second_content__5Ffxz","custom-card":"Second_custom-card__gDDql","p0":"Second_p0__eLwLE","t0":"Second_t0__3pOpn"};